import React, { useEffect, useState } from "react";
import { Grid, Container, Box, TextField } from "@mui/material";
import LocalPhoneTwoToneIcon from "@mui/icons-material/LocalPhoneTwoTone";
import { makeStyles } from "@mui/styles";
import { HashLink as Link } from "react-router-hash-link";
import YouTubeIcon from "@mui/icons-material/YouTube";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import InstagramIcon from "@mui/icons-material/Instagram";
import { useTranslation } from "react-i18next";
import BusinessIcon from "@mui/icons-material/Business";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { getDoc, setDoc, doc, db } from "../../firebase";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",

  boxShadow: 24,
  p: 4,
};

// import { Link } from "react-router-dom";
const Footer = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [email, setEmail] = useState(null);
  const [msg, setMsg] = useState(null);

  const saveMailing = async () => {
    if (ValidateEmail(email)) {
      const docRef = doc(db, "mailing", email);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        await setDoc(doc(db, "mailing", email), {
          email: email,
        });
        setMsg(t("Your email is signed up in our mailing list. Thank you!"));
        handleOpen();
        setEmail("");
      } else {
        setMsg(t("Your email is already signed in."));
        handleOpen();
        setEmail("");
      }
    }
  };

  function ValidateEmail(mail) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
      return true;
    }
    setMsg(t("You have entered an invalid email address"));
    handleOpen();
    return false;
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{ fontSize: "15px", fontWeight: 600 }}>{msg}</Box>
          <button
            onClick={handleClose}
            style={{ marginTop: "20px" }}
            className="custom_btn"
          >
            {t("Close")}
          </button>
        </Box>
      </Modal>
      <Container className={classes.root} maxWidth="100" sx={{ pb: 5 }}>
        <Container className={classes.inside}>
          <Grid container>
            <Grid item md={5} xs={12}>
              <Box pt={3} style={{}}>
                <div className={classes.title}>
                  <img
                    src="/img/heslet_logo.png"
                    width="30"
                    alt="logo"
                    style={{
                      position: "relative",
                      top: "-5px",
                      paddingRight: "5px",
                    }}
                  />
                  Heslet
                </div>
                <div className={classes.email} style={{ paddingTop: "40px" }}>
                  <a
                    href="mailto:support@prisminc.com"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <MailOutlineIcon />
                    &nbsp;&nbsp;
                    <span>contact@heslet.net</span>
                  </a>
                  <a
                    href="mailto:support@heslet.com"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingTop: "15px",
                    }}
                  >
                    <LocalPhoneTwoToneIcon />
                    &nbsp;&nbsp;
                    <div>Heslet Korea 070-7777-4524</div>
                  </a>
                  <a
                    href="mailto:support@heslet.com"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingTop: "5px",
                    }}
                  >
                    <LocalPhoneTwoToneIcon />
                    &nbsp;&nbsp;
                    <div>Heslet USA 1-284-283-2832</div>
                  </a>
                  <a
                    href="mailto:support@heslet.com"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingTop: "15px",
                    }}
                  >
                    <BusinessIcon />
                    &nbsp;&nbsp;
                    <div style={{ fontSize: "13px" }}>{t("c_address")}</div>
                  </a>
                </div>
                <div style={{ paddingTop: "55px" }}>
                  <a
                    href="https://www.youtube.com/channel/UCimi2SVoeswK_I4ttoOSmiw/featured"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <YouTubeIcon style={{ color: "red" }} />
                  </a>
                  <a href="instagram.com" target="_blank" rel="noreferrer">
                    <InstagramIcon
                      sx={{
                        fontSize: "19px",
                        position: "relative",
                        top: "-1px",
                        left: "+3px",
                      }}
                    />
                  </a>
                </div>
                <Box sx={{ mt: 3 }}>
                  <Box sx={{ mb: 1, fontSize: "13px" }}>
                    <MarkEmailReadOutlinedIcon
                      sx={{
                        position: "relative",
                        top: "+3px",
                        fontSize: "14px",
                      }}
                    />{" "}
                    {t("Sign up for mailing list")}
                  </Box>
                  <Box sx={{ marginTop: "15px" }}>
                    <TextField
                      variant="filled"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <button
                      className="custom_btn"
                      style={{
                        width: "90px",
                      }}
                      onClick={saveMailing}
                    >
                      {t("Join")}
                    </button>
                  </Box>
                  {/* <Box
                    sx={{
                      fontSize: "11px",
                      pt: 1,
                      color: "gray",
                      textDecoration: "underline",
                    }}
                  >
                    Unsubscribe
                  </Box> */}
                </Box>
              </Box>
            </Grid>
            <Grid item md={1}></Grid>
            <Grid
              item
              md={2}
              xs={12}
              className={classes.links}
              // style={{ border: "1px solid black" }}
            >
              <Box m={2} pt={3}>
                <div className={classes.footerTitle}>{t("products")}</div>
                <div>
                  <Link
                    smooth
                    to="/products-cleansing#top"
                    className={classes.link}
                  >
                    {t("top_menu1")}
                  </Link>
                </div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/products-living", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("top_menu4")}
                  </Link>
                </div>
                <div>
                  <Link smooth to="/products-pet#top" className={classes.link}>
                    {t("top_menu3")}
                  </Link>
                </div>

                <div
                  className={classes.footerTitle}
                  style={{ paddingTop: "30px" }}
                >
                  {t("customer_service")}
                </div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/faq", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("faq")}
                  </Link>
                </div>
                {/* <div>
                  <Link
                    smooth
                    to={{ pathname: "/return", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("return_policy")}
                  </Link>
                </div> */}
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/contact", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("contact_support")}
                  </Link>
                </div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/guest-order", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("guest_checkout")}
                  </Link>
                </div>
                {/* <div>
									<Link smooth to="/home#top" className={classes.link}>
										Candles & Home Fragrance
									</Link>
								</div> */}
              </Box>
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
              className={classes.links}
              // style={{ border: "1px solid black" }}
            >
              <Box m={2} pt={3}>
                <div className={classes.footerTitle}>{t("our_technology")}</div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/technology", hash: "#hybrid-max" }}
                    className={classes.link}
                  >
                    {t("hybrid_max")}
                  </Link>
                </div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/technology", hash: "#ultra-phenix" }}
                    className={classes.link}
                  >
                    {t("ultra_phenix")}
                  </Link>
                </div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/technology", hash: "#magic-clean" }}
                    className={classes.link}
                  >
                    {t("magic")}
                  </Link>
                </div>
              </Box>
            </Grid>
            <Grid
              item
              md={2}
              xs={12}
              className={classes.links}
              // style={{ border: "1px solid black" }}
            >
              <Box m={2} pt={3}>
                <div className={classes.footerTitle}>{t("company")}</div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/company", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("mission")}
                  </Link>
                </div>
                <div>
                  <Link
                    smooth
                    to={{ pathname: "/company", hash: "#team" }}
                    className={classes.link}
                  >
                    {t("team")}
                  </Link>
                </div>
                <div>
                  <Link
                    to={{ pathname: "/media", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("media")}
                  </Link>
                </div>
                <div>
                  <Link
                    to={{ pathname: "/b2b", hash: "#top" }}
                    className={classes.link}
                  >
                    {t("b2b")}
                  </Link>
                </div>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Container>
      <Box
        className={classes.bottom}
        sx={{
          py: 2,
          display: "flex",

          boxSizing: "border-box",
        }}
      >
        <Grid container sx={{}}>
          <Grid
            item
            md={12}
            sx={{ textAlign: "center", px: { sm: 10, xs: 2 } }}
          >
            &copy; Copyright 2018 - 2022 Heslet LLC. All Rights Reserved
          </Grid>
          <Grid
            item
            md={12}
            sx={{ textAlign: "center", px: { sm: 10, xs: 2 } }}
          >
            <Link to="/privacy">Privacy</Link>&nbsp;|&nbsp;
            <Link to="/terms-and-condition">Terms of Service</Link>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Footer;

const useStyles = makeStyles({
  root: {
    backgroundColor: "#f5f5f5",
    color: "#424242",
    width: "100%",
    zIndex: 100,
    "a:hover": { color: "blue" },
    // borderTop: "1px solid lightgray",
  },
  inside: { paddingTop: "20px", paddingBottom: "20px" },
  title: { fontSize: "22px", display: "flex", alignItems: "center" },
  email: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "80px",
  },
  links: { lineHeight: "2.5em", fontSize: "12px" },
  bottom: {
    width: "100%",
    backgroundColor: "#64676f",
    display: "flex",
    flexDirection: "row",
    color: "#bdbdbd",
  },
  link: { "&:hover": { position: "relative", top: "+1px" } },
  footerTitle: {
    color: "#9e9e9e",
    fontWeight: "bold",
    paddingBottom: "1px",
  },
});
